import React, {  MouseEvent } from 'react';
import classNames from 'classnames';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { getAnimIcon } from '../utils';
import { ANIM_DELETE_ICON, ANIM_PLAY_ICON } from '../../images';
import {  ELEMENT_ICON_LIST } from '../constants';
import Style from '../index.less';
import { AnimType } from '@tencent/slide-sdk-model';
import { ANIM_TYPE_TEXT } from '@src/js/js-keyframe-animation/style-converter/constants';

export type AnimItemHeaderProps = {
    // 可见状态，元素是否被选中或者鼠标悬停，依赖父组件传入
    visible: boolean;
    // 动画类型，依赖父组件传入
    animType: AnimType;
    // 显示的元素名称，依赖父组件传入
    name: string;
    // 元素类型的 icon，依赖父组件传入
    icon: string;
    // 播放按钮点击事件，依赖父组件传入
    onPlay?: () => void;
    // 删除按钮点击事件，依赖父组件传入
    onDelete?: () => void;
    // 元素头部点击事件，播放、删除按钮点击不触发,依赖父组件传入
    onHeaderClick?: (e: MouseEvent) => void;
};

const AnimItemHeader = (props: AnimItemHeaderProps) => {
    const { visible, animType, name, icon, onPlay, onDelete, onHeaderClick } = props;
    const animIcon = getAnimIcon(animType);
    const animName = ANIM_TYPE_TEXT[animType];

    const handleHeaderClick = (e: MouseEvent<HTMLDivElement>) => {
        onHeaderClick?.(e);
    };

    const handlePlay = (e: MouseEvent<HTMLImageElement>) => {
        e.preventDefault();
        e.stopPropagation();
        onPlay?.();
    };

    const handleDelete = (e: MouseEvent<HTMLImageElement>) => {
        e.preventDefault();
        e.stopPropagation();
        onDelete?.();
    };

    return (
        <div className={Style.header} onClick={handleHeaderClick}>
            <img className={classNames(
                Style['header-icon'],
                {
                    [Style['header-icon-big']]: ELEMENT_ICON_LIST.indexOf(icon) === -1,
                },
            )
            }
            src={icon}/>
            <Tooltip
                title={name}
                overlayHoverable={false}
                className={Style['title-tooltip']}
                disabled={name.length < 8}
            >
                <span className={Style['header-title']}>{name}</span>
            </Tooltip>
            {ANIM_TYPE_TEXT[animType]
                ? <>
                    <div
                        className={classNames(
                            Style['header-item-flex'],
                            {
                                [Style['header-item-visible']]: visible,
                                [Style['header-item-hidden']]: !visible,
                            },
                        )}
                        onMouseDown={(e) => {
                            e.stopPropagation();
                        }}>
                        <img className={Style.playIcon}
                            src={ANIM_PLAY_ICON}
                            onClick={handlePlay}/>
                        <img className={Style.deleteIcon}
                            src={ANIM_DELETE_ICON}
                            onClick={handleDelete}/>
                    </div>
                    <div
                        className={classNames({
                            [Style['header-item-visible']]: !visible,
                            [Style['header-item-hidden']]: visible,
                        })}
                    >
                        <Tooltip
                            title={animName}
                            overlayHoverable={false}
                            disabled={animName.length < 8}
                            className={classNames(Style['title-tooltip'], Style['subtitle-tooltip'])}
                        >
                            <div className={Style['subtitle-content']}>
                                { animIcon
                                    ? <img className={Style.headerIcon} src={animIcon}/>
                                    : null
                                }
                                <span className={Style['header-subtitle']}>{animName}</span>
                            </div>
                        </Tooltip>
                    </div>
                </> : null}
        </div>
    );
};

export default AnimItemHeader;
